import { maxBy, meanBy, minBy, range, round, sumBy } from 'lodash'
import moment from 'moment'

export default class DtoYearValues {
    constructor(day, days, minYear) {
        this.day = day
        const currentYear = moment().year()
        days.map((dayData, index) => {
            this[(minYear + index).toString()] = dayData
        })
        const dataWithValues = days.filter(data => data.value && data.value !== null)
        this.min = minBy(dataWithValues, 'value') ? { value: minBy(dataWithValues, 'value').value, color: 'orange' } : { value: null, color: 'orange' }
        this.mean = meanBy(dataWithValues, 'value') ? { value: round(meanBy(dataWithValues, 'value'), 2), color: 'orange' } : { value: null, color: 'orange' }
        this.max = maxBy(dataWithValues, 'value') ? { value: maxBy(dataWithValues, 'value').value, color: 'orange' } : { value: null, color: 'orange' }
        this.sum = sumBy(dataWithValues, 'value') ? { value: round(sumBy(dataWithValues, 'value'), 2), color: 'orange' } : { value: null, color: 'orange' }
        this.headers = ['day'].concat(range(currentYear, minYear - 1).map(i => i.toString())).concat(['min', 'mean', 'max', 'sum'])
    }
}